import React from 'react';
import { CommonStyles } from '../../styles';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
import { View } from 'react-native';
import BaseText from '../BaseText';
import RowView from '../RowView';
import Icon from '../Icon';

const InvoiceCarReceiptCard = ({ item }) => {
  const { tKey } = useComponentTKey('CarCard');
  const { t } = useTranslation(i18nNS.resultCards);
  return (
    <View style={CommonStyles.pt5}>
      <BaseText>{item.CarName}</BaseText>
      <RowView>
        <BaseText>
          {t(tKey('Pickup'))}: {item?.PickupDate} {item?.PickupTime}{' '}
        </BaseText>
        <Icon name="arrowRight" />
        <BaseText>
          {' '}
          {t(tKey('DropOff'))}: {item?.DropoffDate} {item?.DropoffTime}
        </BaseText>
      </RowView>
      <BaseText>
        {t(tKey('Pickup'))}: {item?.PickupAddress}{' '}
      </BaseText>
      <BaseText>
        {t(tKey('DropOff'))}: {item?.DropoffAddress}{' '}
      </BaseText>
      <BaseText>{item?.VendorName}</BaseText>
      <BaseText>
        {t(tKey('Confirmation'))}: {item?.ConfirmationNumber}
      </BaseText>
      <BaseText>
        {t(tKey('Driver'))}: {item?.Passenger}
      </BaseText>
    </View>
  );
};

export default InvoiceCarReceiptCard;
